import { render, staticRenderFns } from "./MultiList.vue?vue&type=template&id=5734e76a&lang=pug&"
import script from "./MultiList.vue?vue&type=script&lang=js&"
export * from "./MultiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports